const translations = {
  $: {
    app_version: '{app} version {version}',
    data_transfer: 'Data Transfer',
    cancel: 'Cancel',
    confirm: 'Confirm',
    continue: 'Continue',
    close: 'Close',
    cpu: 'CPU',
    hpu: 'HPU',
    dont_show_this_message_again: "Don't show this message again",
    draft: 'Draft',
    error: 'Error',
    errors: {
      email: 'Please enter a valid email.',
      email_does_not_exist:
        'The email you provided does not exist in our database. Please register first.',
      generic_header: 'Sorry, we couldn’t fetch this data.',
      invalid_email: 'You have entered an invalid e-mail address. Please try again.',
      login_failed:
        'There was a problem logging you in. Please check your credentials and try again.',
      password: 'Password must have at least 6 characters.',
      try_refreshing: 'Try refreshing the page.',
      unexpected: 'An unexpected error occurred{error}',
      no_data: 'No data available'
    },
    filter_by: 'Search',
    go: 'Go',
    go_to_holofuel: 'Go to HoloFuel',
    happs: 'hApps',
    host_console: 'Host Console',
    hosted_by: 'Hosted by',
    hosting_preferences: 'Hosting Preferences',
    holo: 'HOLO',
    holoport: 'HoloPort',
    holofuel: 'HoloFuel',
    identicon_click:
      'Clicking on an identicon will copy the associated address for easy transacting in HoloFuel.',
    language: {
      en: 'English',
      pl: 'Polski'
    },
    last_7_days: 'Last 7 days',
    learn_more: 'Learn more',
    login: 'Login',
    logging_out: 'Logging out...',
    logout: 'Logout',
    network: 'Network',
    page_not_found: "Hmm... We're unable to find that page.",
    paused: 'Paused',
    published: 'Published',
    rows_per_page: 'Rows per page',
    search: 'Search',
    sort_by: 'Sort by',
    storage: 'Storage',
    tip: 'TIP:',
    try_again: 'Try again',
    your_email: 'Your email'
  },
  holofuel_modal: {
    description:
      'HoloFuel will open in another tab, and you will already be logged in since it uses your same hash ID as {appName}. If you log out of one, you log out of both.'
  },
  login: {
    controlling_your_data: 'about controlling your own data.',
    email: 'Email:',
    password: 'Password:',
    password_reminder:
      '*Remember, Holo doesn’t store your password so we can’t recover it for you. Please save your password securely!',
    subtitle: 'published by Holo'
  }
}

export default translations
